module.exports = __webpack_public_path__ + "static/media/puzzle-12-bg.50907acf.svg";